import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import {
  Box,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Tooltip,
  Typography,
  CircularProgress,
  Paper,
  Divider,
} from "@material-ui/core";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Drag from "../Components/draganddrop";
import cross from "../Assets/cross.svg";
import DummyImage from "../Assets/product_img.svg";
import upload from "../Assets/drag.svg";
import ButtonIconComponent from "../Components/ButtonIcons";
import {
  GetAllData,
  GetSingleDataNestedCollections,
  UpdateSingleDoc,
  UpdateSingleDocNEstedCollections,
} from "../NetworkCalls/Admin/ServerReq";
import UploadImage from "../Components/uploadimage";

function BasicBreadcrumbs() {
  const params = useParams()
  return (
    <div role="presentation">
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          to={`/dashboard/${params.category}/${params.categoryid}`}
          // :category/:categoryId


          // pathname: `/dashboard/${params.category}/${data?.id}/edit_menu/${item?.id}`,




          underline="hover"
          color="#000"
          style={{ color: "#410660" }}
        >
          {" "}
          Edit {params.category}
        </Link>
        <Typography
          color="text.primary"
          style={{ fontWeight: "500", color: "#410660" }}
        >
          Edit Menu
        </Typography>
      </Breadcrumbs>
    </div>
  );
}

const EditMenu = () => {
  const params = useParams();
   const [Error, setError] = useState("");
  const [loader, setLoader] = useState(false);
  const [saveMenuDetailsLoading ,setSaveMenuDetailsLoading] = useState(false)
  const [mainLoader, setMainLoader] = useState(true);
  const [ saveImageLoading,setSaveImageLoading] = useState(false)
  const { state } = useLocation();
  const [open, setOpen] = useState(false);
  const [imgweb, setImgweb] = useState(DummyImage);
  const [tempimg, setTempimg] = useState("");
  const [data, setData] = useState({});


  const [selectedCategory, setSelectedCategory] = useState("");
  const [categories, setCategories] = useState([]);

 

 

  async function handleClick(event) {
    event.preventDefault();
    setOpen(true);
  }

  // console.log(blogdata?.blogimg)
  const { setDragOver, onDragOver, onDragLeave, setFileDropError } = Drag();

  const onDrop = (e) => {
    e.preventDefault();

    setDragOver(false);

    const selectedFile = e?.dataTransfer?.files[0];

    if (selectedFile.type.split("/")[0] !== "image") {
      return setFileDropError("Please provide an image file to upload!");
    }

    setTempimg(selectedFile);
  };

  const handleOnchange = (e) => {
    const { name, value } = e.target;

    if(name === "category") {
      setSelectedCategory(value);

    }

    setData((preValue) => {
      return {
        ...preValue,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    const getDataEditMenu = async () => {
      try {
        setLoader(true);
        const response = await GetSingleDataNestedCollections(
          params.category,
          params?.categoryid,
          "Menu",
          params?.menuid
        );

        setData(response);
        setSelectedCategory(response?.category);

        setLoader(false);
      } catch (err) {
        console.log(err);
        setLoader(false);
      } finally {
        setLoader(false);
      }
    };

    getDataEditMenu();
  }, []);

  useEffect(() => {
    const getAllCategories = async () => {
      try {
        setLoader(true);
        const response = await GetAllData("Categories");

        let arr = [];
        response.forEach((doc) => {
          arr.push(doc.data());
        });

        arr.sort((a, b) => a.name.localeCompare(b.name));

        setCategories(arr);

        setLoader(false);
      } catch (err) {
        console.log(err);
        setLoader(false);
      } finally {
        setLoader(false);
      }
    };

    getAllCategories();
  }, []);


   const handleSaveMenuImage = async (event) => {
    
    setSaveImageLoading(true)
    event.preventDefault();
    setError("");


    UploadImage({ img: tempimg }).then(async (res) => {
      
       
          setImgweb(res);
           await UpdateSingleDocNEstedCollections( params.category,
          params?.categoryid,
          "Menu",
          params?.menuid, { photoLink: res } );

          setSaveImageLoading(false)
        }).catch((e)=>{
          setError(e);
          setSaveImageLoading(true)
        }).finally(()=>{
          setSaveImageLoading(false)
        })

    
  };

  const handleSaveMenuDetails = async ()=>{
    
    setSaveMenuDetailsLoading(true)
    setError("");

    try {
     const response = await UpdateSingleDocNEstedCollections( params.category,
          params?.categoryid,
          "Menu",
          params?.menuid, data);
   
      setSaveMenuDetailsLoading(false)
    } catch (e) {
      setError(e);
      setSaveMenuDetailsLoading(true)
    } finally {
      setSaveMenuDetailsLoading(false)
    }




  }


  

  return (
    <React.Fragment>

      <Grid
        style={{ marginBottom: "10px" }}
        justify="space-between"
        container
        spacing={24}
      >
        <Grid item>
          <Typography variant="h4" gutterBottom display="inline">
            Edit Menu
          </Typography>
        </Grid>
      </Grid>

      <Divider
        my={6}
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          backgroundColor: "#fafafa",
        }}
      />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <BasicBreadcrumbs />
        </Grid>
      </Grid>

      <Divider
        my={6}
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          backgroundColor: "#fafafa",
        }}
      />

      <Paper
        style={{
          boxShadow: "none !important",
          border: "1px solid rgba(76, 78, 100, 0.25)",
          borderRadius: "10px",
          padding: "10px",
        }}
      >


         <Grid item xs={12} xl={6} lg={12} md={6}>
          <h1
            style={{
              fontWeight: "400",
              fontSize: "25px",
              color: "#410660",

              marginBottom: "40px",
            }}
          >
            Menu Information
          </h1>

          {/* ========= */}

          <Grid
            style={{ marginBottom: "10px", marginTop: "35px" }}
            justify="space-around"
            container
            spacing={2}
          >
            <Grid item xs={12} xl={12} lg={12} md={12}>
              <p style={{ fontSize: "11px", marginBottom: "20px" }}>
                Upload Image*
              </p>

              {/* ======= */}

              {imgweb == "" && tempimg == "" ? (
                

                <div className="addImage">
                  <div className="imagebody">
                    <img
                      src={upload}
                      style={{ marginBottom: "20px" }}
                      alt="upload"
                    />
                    <p>
                      Drag and drop an image, or{" "}
                      <label
                        for="upload-photo"
                        className="upload-label"
                        onDragOver={onDragOver}
                        onDragLeave={onDragLeave}
                        onDrop={onDrop}
                      >
                        Browse{" "}
                      </label>
                      <input
                        type="file"
                        name="WebImage"
                        onChange={(e) => {
                          setTempimg(e.target.files[0]);
                        }}
                        id="upload-photo"
                        style={{ display: "none" }}
                        // required={true}
                      />
                      <br /> 1600x1200 or higher recommended. Max 10MB.
                    </p>
                  </div>
                </div>
              ) : (
                <div className="addImage">
                  <>
                    <label
                      for="upload-photo"
                      className="upload-label"
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "relative",
                      }}
                      onDragOver={onDragOver}
                      onDragLeave={onDragLeave}
                      onDrop={onDrop}
                    >
                      <input
                        type="file"
                        name="WebImage"
                        onChange={(e) => {
                          // UploadImage({ img: e.target.files[0] }).then(
                          //   (res) => {

                          //     setImgweb(res);
                          //   }
                          // );
                          setTempimg(e.target.files[0]);
                        }}
                        id="upload-photo"
                        style={{ display: "none" }}
                      />

                      <img
                        src={cross}
                        style={{
                          width: "35px",
                          top: "-25px",
                          position: "absolute",
                          right: "-25px",
                        }}
                        onClick={() => {
                          tempimg == "" ? setImgweb("") : setTempimg("");
                        }}
                      />
                      {tempimg == ""  ? (
                        <img
                          src={  data?.photoLink}
                          style={{ width: "100%", height: "100%" }}
                        />
                      ) : (
                        <img
                          src={URL.createObjectURL(tempimg)}
                          style={{ width: "100%", height: "100%" }}
                        />
                      )}
                    </label>
                  </>
                </div>
              )}

              {/* ======== */}
            </Grid>
          </Grid>

          {/* ======== */}

          <div
            style={{
              width: "30%",
            }}
          >
            <ButtonIconComponent
              loader={saveImageLoading}
              name="Save Image"
             
              onClick={handleSaveMenuImage}
              imageBool={false}
            />
          </div>
        </Grid>



       
        <form>
          <Grid
            style={{ marginBottom: "10px", marginTop: "35px" }}
            container
            spacing={2}
          >
            <Grid item xs={12} xl={6} lg={6} md={6}>
              <TextField
                id="  -basic"
                type="text"
                name="name"
                label="Enter menu name"
                variant="outlined"
                value={data?.name}
                InputLabelProps={{ shrink: true }}
                onChange={handleOnchange}
                fullWidth={true}
              />
            </Grid>

            <Grid item xs={12} xl={6} lg={6} md={6}>
              <TextField
                id="outlined-basic"
                type="text"
                name="price"
                label="Enter menu price"
                variant="outlined"
                value={data?.price}
                InputLabelProps={{ shrink: true }}
                onChange={handleOnchange}
                fullWidth={true}
              />
            </Grid>

            <Grid item xs={12} xl={6} lg={6} md={6}>
              <TextField
                id="outlined-basic"
                type="text"
                name="description"
                label="Enter menu description"
                variant="outlined"
                value={data?.description}
                InputLabelProps={{ shrink: true }}
                onChange={handleOnchange}
                fullWidth={true}
              />
            </Grid>

            <Grid item xs={12} xl={6} lg={6} md={6}>
            

              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select menu category
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Enter menu category"
                  name="category"
                  value={selectedCategory}
                  onChange={handleOnchange}
                >
                  {categories &&
                    categories.map((item, index) => (
                      <MenuItem key={index} value={item?.id}>
                        {item?.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box>
            <ButtonIconComponent
              loader={saveMenuDetailsLoading}
              name="Save"
              onClick={handleSaveMenuDetails}
              imageBool={false}
            />
          </Box>
        </form>
      </Paper>
    </React.Fragment>
  );
};

export default EditMenu;
